import httpService from '@/core/http-service'
import priceService from '@/core/price-service'
import _ from 'lodash'
import Vue from 'vue'
import { showMandatoryCommentModal } from '@/core/modal-service'
import cartService from '../core/cart-service'
import utils, { sharedText } from '../core/utils'

const state = {
  cart: {},
  currentProduct: null,
  cartSelectedRows: { },
  campaign: {},
  giftCard: {},
  superUserMyCart: {}
}

const mutations = {
  set_cart(state, payload) {
    state.cart = payload
  },
  set_selected_rows(state, payload) {
    Vue.set(state.cartSelectedRows, payload.cartId, payload.data)
  },
  set_currentProduct(state, payload) {
    state.currentProduct = payload
  },
  set_campaign (state, payload) {
    state.campaign = payload
  },
  set_giftCard (state, payload) {
    state.giftCard = payload
  },
  set_superUserMyCart (state, payload) {
    state.superUserMyCart = payload
  }
}

const actions = {
  getCart({ commit }, cartType) {
    return httpService.get('cart/getCart', { cartType }).then(({ data }) => {
      commit('set_cart', data.data)
    })
  },
  setCart({ commit }, payload) {
    commit('set_cart', payload)
  },
  getProduct({ commit }, { productId, products }) {
    const body = _.isArray(productId) ? { productId } : { productId: [ productId ] }
    httpService.post('productListPrices', body).then((response) => {
      priceService.populatePricesFromBackend(response.data, products)
      commit('set_currentProduct', products[0])
    })
  },
  async addToCart({ dispatch }, payload) {
    const requestPayload = {
      rows: [{
        itemId: payload.itemId,
        productId: payload.productId,
        purchasedOnCategory: payload.purchasedOnCategory,
        quantity: payload.quantity || 1,
        purchasedToVehicle: payload.purchasedToVehicle,
        mandatoryComment: payload.mandatoryComments
      }]
    }

    return dispatch('addListToCart', requestPayload)
  },
  async addListToCart({ dispatch, rootGetters }, payload) {
    const machineMarking = rootGetters['myMachines/hasGlobalSelection'] ? { machineId: rootGetters['myMachines/globalMachine'], machineOwnerId: rootGetters['myMachines/globalMachineOwner'], isGlobalSelection: true } : { machineId: payload.machineId, machineOwnerId: payload.machineOwnerId, isGlobalSelection: false }

    // Add query parameters if present
    const chatSession = utils.getQueryStringParam('chatSession')
    const exchangeId = utils.getQueryStringParam('exchangeId')
    const queryParams = {}
    if (chatSession) queryParams.chatSessionId = chatSession
    if (exchangeId) queryParams.exchangeId = exchangeId

    const requestPayload = {
      rows: payload.rows,
      ...machineMarking,
      ...queryParams
    }
    const { data } = await httpService.post('cart/addToCart', requestPayload, { cartType: rootGetters.clientModel.cartType })
    return dispatch('handleAddToCartResponse', { body: requestPayload, response: data })
  },
  async handleAddToCartResponse({ commit, dispatch }, payload) {
    if(payload.response.cart) commit('set_cart', payload.response.cart)
    else if(payload.response.mandatoryComment) {
      const comments = await showMandatoryCommentModal({ mandatoryComment: payload.response.mandatoryComment, title: sharedText('addMandatoryComment') })
      if(comments) {
        cartService.setMandatoryCommentOnCartItems(payload.body.rows, comments)
        return dispatch('addListToCart', payload.body)
      }
    }
    return payload.response
  },
  deleteFromCart({ commit, rootGetters }, payload) {
    return httpService.delete('cart/deleteFromCart', { ...payload, cartType: rootGetters.clientModel.cartType }).then(({ data }) => {
      commit('set_cart', data)

      return data
    })
  },
  deleteRowsFromCart({ commit }, payload) {
    return httpService.deleteWithBody('cart/deleteRowsFromCart', payload).then(({ data }) => {
      commit('set_cart', data)

      return data
    })
  },
  changeQuantity({ commit, rootGetters }, payload) {
    return httpService.post('cart/changeQuantity', { cartItems: [...payload], cartType: rootGetters.clientModel.cartType }).then(({ data }) => {
      commit('set_cart', data)
    })
  },
  applyCampaign({ commit }, payload) {
    return httpService.post('checkout/applyCampaignCode', payload).then(({ data }) => {
      commit('set_campaign', data)
    })
  },
  removeGiftCardCode({ commit }, payload) {
    return httpService.post('checkout/removeGiftCardCode', payload).then(({ data }) => {
      // commit('set_cart', data)
    })
  },
  getSuperUserMyCart({ commit }) {
    return httpService.get('superuser/cart/superUserMyCart').then(({ data }) => {
      commit('set_superUserMyCart', data.data)
    })
  }
}

const getters = {
  cart: state => state.cart,
  currentProduct: state => state.currentProduct,
  cartSelectedRows: state => state.cartSelectedRows,
  campaign: state => state.campaign,
  giftCard: state => state.giftCard,
  numberOfItems: state => state.cart.numberOfItems,
  superUserMyCart: state => state.superUserMyCart
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
